import { Injectable } from '@angular/core';
import { DwoCheckListGroupItemMappingViewModel } from '../business-entities/dwo-check-list-group-item-mapping-view-model';
import { AddCheckListRequestModel } from '../business-entities/dwo-check-list-group-mapping-view-model';
import { DwoCheckListRequestModel } from '../business-entities/dwo-check-list-request-model';
import { DwoSubCheckListDetailViewModel } from '../business-entities/dwo-sub-check-list-detail-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { VehicleType } from './../business-entities/vehicleTypes-model';
import { CheckListDataService } from './../data-services/check-list-data.service';
@Injectable({
  providedIn: 'root'
})
export class CheckListBusinessService {

  checkList: DwoSubCheckListDetailViewModel;
  check: string
  IsAddItems: string
  selectedBrand: string
  selectedVehicleType: string
  isEdit: boolean = false;
  checkListId:number=0;
  checkListItemId:number=0;
  duplicateChecklist: boolean = false;
  multiColorSelect: boolean = false;
  checkListItemData: any;
  colourCheckListType: number;
  showPredefinedChecklist: boolean = false;
  
  constructor(private checkListDataService: CheckListDataService) { }

  getCheckList(param: DwoCheckListRequestModel): Promise<GenericResponse<DwoSubCheckListDetailViewModel>> {
    return this.checkListDataService.getCheckList(param);
  }

  addCheckList(param: AddCheckListRequestModel): Promise<GenericResponse<any>> {
    return this.checkListDataService.addCheckList(param);
  }

  addCheckListItem(param: DwoCheckListGroupItemMappingViewModel): Promise<GenericResponse<any>> {
    return this.checkListDataService.addCheckListItem(param);
  }

  deleteCheckList(param: any): Promise<GenericResponse<any>> {
    return this.checkListDataService.deleteCheckList(param);
  }

  getCheckListByMappingId(model: any): Promise<GenericResponse<any>> {
    return this.checkListDataService.getCheckListByMappingId(model);
  }

  updateCheckList(model: any): Promise<GenericResponse<any>> {
    return this.checkListDataService.updateCheckList(model);
  }

  createDuplicateCheckList(model: any): Promise<GenericResponse<any>> {
    return this.checkListDataService.createDuplicateCheckList(model);
  }

  updateCheckListItems(model: any): Promise<GenericResponse<any>> {
    return this.checkListDataService.updateCheckListItems(model);
  }
  
  getCheckListItemsByMappingId(mappingId: number): Promise<GenericResponse<any>> {
    return this.checkListDataService.getCheckListItemsByMappingId(mappingId);
  }
  getColorCheckListItemsByMappingId(mappingId: number): Promise<GenericResponse<any>> {
    return this.checkListDataService.getColorCheckListItemsByMappingId(mappingId);
  }

  getVehicleTypes(): Promise<GenericResponse<Array<VehicleType>>> {
    return this.checkListDataService.getVehicleTypes();
  }

}
